<app-not-auth-header></app-not-auth-header>

<div class="container">
    <h3 class="mt-4 text-center">Hei, pyydä kirjautumislinkki pääyhteyshenkilöltänne.</h3>

</div>
